'use client'

import { Box, SxProps, Theme, Typography } from '@mui/material'
import { ReactElement } from 'react'
import { tss } from 'tss-react/mui'
import { IconType } from '../Icon'

const useStyles = tss
    .withName('Metadata')
    .withNestedSelectors<'hasIcon'>()
    .create(({ theme, classes }) => ({
        root: {
            display: 'flex',
            alignItems: 'center',
            paddingTop: theme.spacing(0.25),
        },
        text: {
            marginLeft: 0,
            wordBreak: 'break-word',

            [`&.${classes.hasIcon}`]: {
                marginLeft: theme.spacing(0.75),
            },
        },
        hasIcon: {},
    }))

export type MetadataProps = {
    Icon?: IconType
    text: ReactElement | string
    clamp?: 1 | 2
    sx?: SxProps<Theme>
    className?: string
}

const Metadata = ({ Icon, text, clamp, sx, className }: MetadataProps): ReactElement => {
    const { classes, cx } = useStyles()

    return (
        <Box sx={sx} className={cx(classes.root, className)}>
            {Icon ? <Icon color="action.active" small /> : null}
            <Typography
                variant="body2"
                color="textSecondary"
                className={cx(classes.text, Icon && classes.hasIcon, clamp && `line-clamp-${clamp}`)}
            >
                {text}
            </Typography>
        </Box>
    )
}

export default Metadata
